import { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom';
import { get } from '../api/apiService'
import { useTheme } from '../theming/default_theme';
import Menu from './Menu/Menu';
import Header from './Header';
import { convertDateFormat, formatDate } from '../utils/dateUtils';
import { useNavigate } from 'react-router-dom';
import StatusBadge from './StatusBadge';
import { apiEndPoints } from '../api/apiEndPoints';
import blockUser from '../assets/icons/blockuser.png';
import mapPin from '../assets/icons/map-pin.png';
import phone from '../assets/icons/phone.png';
import userPlus from '../assets/icons/user-plus.png';
const VisionAmbassadorDetailsPage: React.FC = () => {

    const theme = useTheme();
    const navigate = useNavigate();
    const { ambassadorId } = useParams();
    const location = useLocation();
    const ambassador = location.state?.ambassador;
    const [ambassadorsRefList, setAmbassadorsRefList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageCountIndex, setPageCountIndex] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [selectedTab, setSelectedTab] = useState('Referrals');
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);
    const [pageSize, setPageSize] = useState(5);
    const [pageNumber, setPageNumber] = useState(0);
    const [selectedPage, setSelectedPage] = useState('0');
    const [pagesToDisplay, setPagesToDisplay] = useState(Array.from({ length: 5 }, (_, index) => index + 1));


    useEffect(() => {
        console.log('the ambassador details are:', ambassador);
        if (!ambassador) {
            navigate('/LandingPage', { replace: true });
        }
        const fetchAmbassadorReferralsById = async (Id: string) => {
            try {
                setLoading(true);
                const url = `${apiEndPoints.ambassadorReferralURL}/${Id}`;
                const response = await get(url);
                console.log('API Response:', response);
                setLoading(false);
                if (response) {
                    setAmbassadorsRefList(response);
                }
                else
                    console.log('refresh and check');
            } catch (err) {

            }
        };
        if (ambassadorId)
            fetchAmbassadorReferralsById(ambassadorId);
        else
            console.error('hospital not selected');
    }, [selectedTab,ambassador,navigate])

    if(!ambassador){
        return null;
    }

    const handleHospitalClick = () => {
        navigate('/LandingPage');
    };

    const handlePageChange = async (event: React.MouseEvent<HTMLDivElement>) => {
        setSelectedPage(event.currentTarget.innerText);
        console.log('selectedPage:', selectedPage);
        console.log('selectedPage.includesnext --:', selectedPage.includes('Next'));
        console.log('pageNumber:', pageNumber);
        if (selectedPage.includes('Prev')) {
            if (pageNumber == 0) {

            }
            else {

                if (pageNumber % 5 === 0) {
                    setPagesToDisplay(Array.from({ length: 5 }, (_, index) => index - 5));

                }
                setSelectedPage((pageNumber - 1).toString());


            }
            console.log('selectedPage:', selectedPage);
        }

        else if (selectedPage.includes('Next')) {
            console.log('selectedPage:-', selectedPage);
            console.log('you are in next');

            if (pageNumber == totalPages - 1) {

            }
            else {
                if ((pageNumber % 5) === 4) {
                    setPagesToDisplay(Array.from({ length: 5 }, (_, index) => index + 6));

                }
                setSelectedPage((pageNumber + 1).toString());
            }
        }
    }

    return (
        <div className={` flex flex-row justify-start items-start h-screen w-screen`} >
            <Menu />
            <div className="flex flex-col justify-start items-start w-full h-full">
                <Header />
                <div className="flex flex-col h-full w-full border border-2 mt-2" style={{ backgroundColor: theme.colors.background }}>
                    <div className="flex flex-row justify-start text-left items-left ml-5 gap-2">
                        <div className="cursor-pointer" onClick={() => handleHospitalClick()}>{`Vision Ambassador`}</div>
                        <span className="px-2">{`>`}</span> {/* Adds space before and after the symbol */}
                        <div>{`Ambassador Details`}</div>
                    </div>
                    <div className={`flex  flex-col w-[95%] h-[20%] mt-2 ml-5 bg-[${theme.colors.surfaceCard}] border-r-${theme.borders.color} rounded-xl`}>
                        <div className={`flex flex-col w-full pl-5 justify-start items-start text-center text-[${theme.colors.text}] font-bold`} style={{ fontSize: theme.typography.h1.fontSize, fontFamily: theme.typography.fontFamily, fontWeight: theme.typography.fontWeightBold, color: theme.colors.text }}>
                            <div className="flex flex-row justify-center items-center gap-x-5 pt-2 pl-5 mb-1">
                                <img src={blockUser} alt="Visio Ambassador" style={{ width: '50px', height: '50px' }} />
                                {ambassador.name}
                            </div>

                            <hr className="flex flex-row justify-center border-t-2 border-[#27AE60] w-[99%] pl-2 pr-2 mt-1 mb-1" />
                        </div>
                        <div className="flex flex-row justify-between items-center w-full h-auto ml-5 px-5 py-2">
                            <div className="flex items-center">
                                <img src={mapPin} alt="Location Icon" className="w-5 h-5 mr-2" />
                                <span className="font-bold">Location:</span>
                                <span className="ml-1 font-normal">{ambassador.state}</span>
                            </div>
                            <div className="flex items-center">
                                <img src={phone} alt="Location Icon" className="w-5 h-5 mr-2" />
                                <span className="font-bold">Contact Number:</span>
                                <span className="ml-1 font-normal">{ambassador.phoneNumber}</span>
                            </div>
                            <div className="flex items-center">
                                <img src={userPlus} alt="Location Icon" className="w-5 h-5 mr-2" />
                                <span className="font-bold">Total Referrals:</span>
                                <span className="ml-1 font-normal mr-4">{ambassadorsRefList.length}</span>
                            </div>
                        </div>
                    </div>

                    <div className={`flex  flex-col w-[95%] h-[50%] mt-5 ml-5  mb-5 bg-[${theme.colors.surfaceCard}] border-r-${theme.borders.color} border-black rounded-xl`}>
                        <div
                            className="font-bold text-lg mt-2 mb-1"
                            style={{
                                fontWeight: 'bold', // Makes the text bolder
                                marginTop: '10px', // Moves the text slightly downward
                                marginLeft: '24px', // Aligns it with the table
                            }}
                        >
                            Referrals
                        </div>
                        <div className={`flex  justify-start items-center ml-[24px]  w-[96%] h-[85%] border border-[${theme.borders.color}] rounded-xl`} style={{ backgroundColor: theme.colors.secondary, justifyItems: "start", alignItems: "start", overflowY: "auto" }}>
                            <table className="table-fixed h-full text-start" style={{ width: "100%", height: "100%", border: theme.borders.color, borderRadius: "8px", overflow: "auto", justifyItems: "start", alignItems: "start", justifyContent: "left", textAlign: 'left', fontFamily: theme.typography.fontFamily, fontWeight: theme.typography.fontWeightBold, fontSize: theme.typography.fontSize, color: theme.colors.text }}>
                                <thead className={`w-full sticky top-0 font-bold bg-[${theme.colors.surfaceCard}]`} style={{ borderBottomColor: theme.borders.color }}>
                                    <tr>
                                        <th
                                            className="w-[30%] text-start px-4 py-2 sticky top-0 z-10"
                                            style={{ position: 'sticky', top: 0, zIndex: 10 }}
                                        >
                                            Referred
                                        </th>
                                        <th
                                            className="w-[20%] text-start px-4 py-2 sticky top-0 z-10"
                                            style={{ position: 'sticky', top: 0, zIndex: 10 }}
                                        >
                                            Age & Gender
                                        </th>
                                        <th
                                            className="w-[20%] text-start px-4 py-2 sticky top-0 z-10"
                                            style={{ position: 'sticky', top: 0, zIndex: 10 }}
                                        >
                                            Referred On
                                        </th>
                                        <th
                                            className="w-[20%] text-start px-4 py-2 sticky top-0 z-10"
                                            style={{ position: 'sticky', top: 0, zIndex: 10 }}
                                        >
                                            Status
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className={`w-full text-start border border-[${theme.borders.color}]`}>
                                    {(ambassadorsRefList && ambassadorsRefList.length > 0) ? (
                                        ambassadorsRefList.map((ambassadorRef: any, index: number) => (
                                            <tr key={index} className={`w-full text-start border border:theme.borders.color`}>
                                                <td className={`w-full h-[10%] text-start block px-4 py-2 align-top`}>{ambassadorRef?.patientName}</td>
                                                <td className="h-[10%] w-full px-4 py-2 text-start align-top">{`${ambassadorRef.age}, ${ambassadorRef.gender}`}</td>
                                                <td className={`h-[10%] w-full text-start block px-4 py-2 align-top`}>{convertDateFormat(ambassadorRef.createdAt)}</td>
                                                <td
                                                    className="h-[10%] px-2 py-2 align-top"
                                                    style={{ textAlign: "left" }}
                                                >
                                                    {(() => {
                                                        const status = ambassadorRef.status?.toLowerCase();
                                                        switch (status) {
                                                            case "delivered":
                                                                return (
                                                                    <StatusBadge
                                                                        backgroundColor="#E8F6EE"
                                                                        textColor="#27AE60"
                                                                        text="Delivered"
                                                                    />
                                                                );
                                                            case "referred":
                                                                return (
                                                                    <StatusBadge
                                                                        backgroundColor="#F2F8FD"
                                                                        textColor="#2980B9"
                                                                        text="Referred"
                                                                    />
                                                                );
                                                            default:
                                                                return (
                                                                    <StatusBadge
                                                                        backgroundColor="#FFF8DC"
                                                                        textColor="#FFC107"
                                                                        text="In Progress"
                                                                    />
                                                                );
                                                        }
                                                    })()}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={4} className="text-center py-10" style={{
                                                fontFamily: theme.typography.fontFamily,
                                                fontWeight: theme.typography.fontWeightBold,
                                                fontSize: theme.typography.fontSize,
                                                color: theme.colors.text,
                                            }}>
                                                No referrals found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>

                        </div>

                    </div>


                </div>
            </div>

        </div>
    );
}
export default VisionAmbassadorDetailsPage;